/* ==========================================================================
   LUX — Cinematic brand loader

   Sequences the loader with setTimeout against a duration computed from the
   CSS choreography — no rAF loop, no per-frame work. Every animation itself
   is a plain CSS `animation`/`transition` that starts automatically the
   moment the element is visible, so this file only ever needs to schedule
   two class toggles and clean up. It is never the reason a customer waits:
   a hard safety timeout guarantees the loader is gone even if something
   above goes wrong, an image fails, or the tab was backgrounded.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.getElementById('lux-loader');
  if (!root) return;

  // Skip path — decided synchronously in the inline script in the snippet,
  // before first paint. Nothing left to do here.
  if (root.getAttribute('data-skip') === 'true') {
    finish(true);
    return;
  }

  var SPEED_SCALE = { slow: 1.3, normal: 1, fast: 0.72 }[root.getAttribute('data-speed')] || 1;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var HOLD_MS = 550;
  var EXIT_MS = 560;
  var SAFETY_MS = 6000; // absolute ceiling — the loader is guaranteed to end by here no matter what.

  function computeSettleMs() {
    if (reduceMotion) return 120;

    var chars = root.querySelectorAll('.lux-loader__char');
    var lastCharDelay = chars.length ? (160 + (chars.length - 1) * 28) : 0;
    var charSettle = lastCharDelay + 560;
    var tileSettle = 460 + 520; // last tile's own delay + duration, fixed by the CSS composition
    return Math.max(charSettle, tileSettle);
  }

  function lockScroll() {
    document.documentElement.classList.add('lux-loading-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('lux-loading-lock');
  }

  var finished = false;

  function finish(skip) {
    if (finished) return;
    finished = true;

    window.clearTimeout(safetyTimer);

    if (!skip) unlockScroll();

    root.classList.add('is-done');

    if (root.getAttribute('data-frequency') === 'first_visit') {
      try { sessionStorage.setItem('lux:loader:seen', '1'); } catch (e) { /* ignore */ }
    }
  }

  function exit() {
    root.classList.add('is-exiting');
    window.setTimeout(function () { finish(false); }, Math.round((reduceMotion ? 200 : EXIT_MS) * SPEED_SCALE));
  }

  // Absolute ceiling: whatever else happens, the loader is gone by SAFETY_MS.
  var safetyTimer = window.setTimeout(function () { finish(false); }, SAFETY_MS);

  lockScroll();

  var settleMs = computeSettleMs();
  var holdMs = reduceMotion ? 80 : HOLD_MS;
  var startExitAfter = Math.round((settleMs + holdMs) * SPEED_SCALE);

  window.setTimeout(exit, startExitAfter);
})();
